module.exports = "img/flags/PW.e1f0248.png";